/**
 *  Register.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 06/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";

// template
import { Grid, Row, Col,FormGroup, FormControl, ControlLabel } from "react-bootstrap";

// redux
import { connect } from 'react-redux';

// components
import { Card } from "../../components/Card/Card.jsx";
import VideosList from "./VideosList.jsx";
import Loading from "../Loader/Loader.jsx";

// notifications
import NotificationSystem from "react-notification-system";

// style
import './style.css';
import { style } from "../../variables/Variables.jsx";

// global
var firebase = require("../../firebase");
var utils = require("../../utils")

class Videos extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            name: "",
            videoUrl: "",
            _notificationSystem: null,
            list: []
        };
    }

    componentDidMount() {
        document.title = "Security Care | Videos";
        this.setState({ _notificationSystem: this.refs.notificationSystem });
    }

    componentWillMount() {
        this.reloadData();
    } 

    reloadData = () => {
        this.setState({ loading: true })
        firebase.database.ref('videos').orderByChild("createdAt").once('value').then((snap) => {
            let list = []
            const values = snap.val()
            for (let key in values) {
                let value = values[key]
                value["key"] = key
                list.unshift(value)
            }
            this.setState({ list, loading: false });
        });
    }

    createNew = _ => {
        const { name, videoUrl } = this.state
        if(name && videoUrl) {
            this.setState({ loading: true })
            firebase.database.ref('videos').push({
                createdAt: (new Date()).getTime(),
                status: 1,
                title: name,
                url: videoUrl
            }).then(_ => {
                this.setState({ name: "", videoUrl: "" })
                this.notify("Cerca cadastrada com sucesso", "success")
                this.reloadData()
            });
        } else {
            this.notify("Favor preencher todos os dados", "error")
        }
    }

    handleChange = (evt) => {
        this.setState({ [evt.target.name]: evt.target.value});
    }

    notify = (message, level) =>  {
        this.state._notificationSystem.addNotification({
          title: <span data-notify="icon" className="pe-7s-bell" />,
          message: <div>{message}</div>,
          level: level,
          position: "tr",
          autoDismiss: 10
        });
    }
    
    render() {
        const { name, videoUrl, list, loading } = this.state;

        return (
            <div className="content bg-content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title="CADASTRAR NOVO VIDEO"
                                content={
                                    <div>
                                        <Col md={3}>
                                            <div className='form-group'>
                                                <FormGroup controlId="formControlsTextarea">
                                                    <ControlLabel style={{fontWeight: 'bold'}}>Nome</ControlLabel>
                                                    <FormControl
                                                        componentClass='input'
                                                        placeholder='Informe o nome'
                                                        name='name'
                                                        value={name}
                                                        onChange={this.handleChange}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>

                                        <Col md={6}>
                                            <div className='form-group'>
                                                <FormGroup controlId="formControlsTextarea">
                                                    <ControlLabel style={{fontWeight: 'bold'}}>URL</ControlLabel>
                                                    <FormControl
                                                        componentClass='input'
                                                        placeholder='Informe o link do video'
                                                        name='videoUrl'
                                                        value={videoUrl}
                                                        onChange={this.handleChange}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div class="form-group">
                                                <br></br>
                                                <button type="button" class="btn btn-info labelless" style={{fontWeight: 'bold'}} onClick={this.createNew}>
                                                    <span class="glyphicon glyphicon-plus"></span> CADASTRAR
                                                </button>
                                            </div>
                                        </Col>
                                        <div className="clearfix" />
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            { loading ?
                                <Loading /> 
                            :
                                <VideosList list={list} reload={this.reloadData} />
                            }
                                
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    };
}

const mapStateToProps = store => ({
    users: store.users.users
});

export default connect (mapStateToProps)(Videos);



// WEBPACK FOOTER //
// ./src/views/Videos/Videos.jsx